import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Heart, ArrowRight } from 'lucide-react';

const PatientOnboarding = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState(0);

  const steps = [
    {
      title: 'Welcome to CircleUpSquad.',
      content: (
        <div className="space-y-4 text-center">
          <p className="text-base text-muted-foreground leading-relaxed">
            We hate to meet this way, and bet you feel the same.
          </p>
          <p className="text-base text-muted-foreground leading-relaxed">
            As fellow survivors and patients, the team that created CircleUpSquad knows how crucial it is to receive good care.
          </p>
          <p className="text-base text-foreground font-medium leading-relaxed">
            This is our way to make that easier and more simple for you.
          </p>
        </div>
      ),
    },
    {
      title: "Here's how it works:",
      content: (
        <div className="space-y-4 text-left max-w-sm mx-auto">
          {[
            'Create your account',
            'Name your CareSquad',
            'Invite your trusted support team',
            'Post what you need — your squad steps up',
            'Connect with your CircleUp Coach',
          ].map((text, i) => (
            <div key={text} className="flex items-start gap-3">
              <div className="w-7 h-7 rounded-full bg-cyan-500 text-white flex items-center justify-center text-sm font-bold flex-shrink-0 mt-0.5">
                {i + 1}
              </div>
              <p className="text-base text-foreground">{text}</p>
            </div>
          ))}
        </div>
      ),
    },
  ];

  const current = steps[step];
  const isLast = step === steps.length - 1;

  return (
    <div className="min-h-screen flex items-center justify-center px-5" data-testid="patient-onboarding">
      <div className="max-w-lg w-full text-center space-y-8 fade-in">
        <div className="flex justify-center">
          <div className="relative w-20 h-20 flex items-center justify-center">
            <div className="absolute inset-0 rounded-full border-2 border-cyan-300/40 animate-pulse" />
            <div className="absolute inset-3 rounded-full border-2 border-cyan-400/60" />
            <div className="absolute inset-6 rounded-full border-2 border-cyan-500/80" />
            <div className="w-8 h-8 bg-red-500 rounded-full flex items-center justify-center shadow-lg">
              <Heart className="w-4 h-4 text-white" fill="currentColor" />
            </div>
          </div>
        </div>

        <h1 className="text-2xl sm:text-3xl font-bold text-foreground tracking-tight" style={{ fontFamily: 'Outfit, sans-serif' }}>
          {current.title}
        </h1>

        {current.content}

        <div className="flex gap-2 justify-center mb-4">
          {steps.map((_, i) => (
            <div key={`dot-${i}`} className={`h-1.5 rounded-full transition-all duration-300 ${i === step ? 'w-8 bg-cyan-500' : 'w-3 bg-muted'}`} />
          ))}
        </div>

        <div className="max-w-xs mx-auto">
          <Button
            size="lg"
            className="btn-primary text-base w-full h-12"
            onClick={() => {
              if (isLast) {
                navigate('/auth', { state: { role: 'patient' } });
              } else {
                setStep(step + 1);
              }
            }}
            data-testid="onboarding-next-btn"
          >
            {isLast ? "Let's get started" : 'Continue'}
            <ArrowRight className="w-4 h-4 ml-2" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PatientOnboarding;
